import i18n from "i18next";
import type { FC } from "react";
import { useNavigate } from "react-router";

import { BASE_PATH } from "../../core/router/types/routerTypes";
import type { Entity } from "../../core/types/fe/Entity";
import { SecondaryButton } from "../Buttons/components/ActionButton";

export type BatchUpdateButtonProps = {
    resourceName: string;
    isDisabled: boolean;
    callback?: () => void;
    itemsToUpdate: Entity[];
};

export const BatchUpdateButton: FC<BatchUpdateButtonProps> = ({ resourceName, isDisabled, callback, itemsToUpdate }) => {
    const navigate = useNavigate();

    const ids = itemsToUpdate.map((item) => item.id).join(",");
    const onClick = () => navigate(`${BASE_PATH}/${resourceName}/batch-update?ids=${ids}`);

    return (
        <SecondaryButton name="batch_update_button" onClick={callback || onClick} disabled={isDisabled}>
            {i18n.t("button.batchUpdate")}
        </SecondaryButton>
    );
};
